import { render, staticRenderFns } from "./movement.vue?vue&type=template&id=97da0a86&scoped=true&"
import script from "./movement.vue?vue&type=script&lang=js&"
export * from "./movement.vue?vue&type=script&lang=js&"
import style0 from "./movement.vue?vue&type=style&index=0&id=97da0a86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97da0a86",
  null
  
)

export default component.exports